import { Checkbox, Col, Radio, Row } from 'antd';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import { StyledCheckbox } from 'app/pages/Cart/components/PaymentInfo';
import React, { CSSProperties } from 'react';
import { useSelector } from 'react-redux';

export const CustomCheckBox = (options: any, value: any, onChange: any) => {
  return (
    <Checkbox.Group
      onChange={onChange}
      value={value}
      style={{ display: 'flex', flexDirection: 'column', rowGap: 10 }}
    >
      {options.map((item: any, index: any) => (
        <div key={item.value || index}>
          <Checkbox
            style={{
              fontWeight: value.includes(item.value) ? 500 : 400,
              color: '#000000',
              wordBreak: 'break-word',
            }}
            value={item.value}
          >
            {item.label}
          </Checkbox>
        </div>
      ))}
    </Checkbox.Group>
  );
};
export const CustomPopoverContent = (
  valueType: any,
  onChangeType: any,
  valueObject: any,
  onChangeObject: any,
  listType: any,
  listObject: any,
) => {
  const translations = useSelector(selectTranslations);
  return (
    <div className="popover-content" style={{ minWidth: 130, margin: 4 }}>
      <div style={{ fontWeight: 600 }}>
        {translations ? translations['b2b.text.filter-ticket-type'] : ''}
      </div>
      {CustomCheckBox(listType, valueType, onChangeType)}
      <div style={{ fontWeight: 600 }} className=" mt-2">
        {translations ? translations['b2b.text.filter-objects'] : ''}
      </div>
      {CustomCheckBox(listObject, valueObject, onChangeObject)}
    </div>
  );
};

export const CustomRadio = (options: any, value: any, onChange: any) => {
  return (
    <Radio.Group value={value} onChange={onChange} size="large">
      {options.map((item: any, index: any) => (
        <Radio key={index} value={item?.value}>
          {item?.label}
        </Radio>
      ))}
    </Radio.Group>
  );
};
export const safeNumber = (value: unknown, fallback: number): number => {
  if (value === null || value === undefined || value === '') {
    return fallback;
  }
  const n = Number(value);
  return Number.isNaN(n) ? fallback : n;
};
export const formatDescriptionCatalog = (text: string = '') => {
  return text
    .replace(/_?x000D_?/gi, '')
    .replace(/\\r\\n|\\n|\\r/g, '\n')
    .replace(/(^|[\s>])(www\.[^\s<]+)/gi, '$1<a href="https://$2">$2</a>')
    .replace(/(^|[\s>])(https?:\/\/[^\s<]+)/gi, '$1<a href="$2">$2</a>')
    .replace(
      /<a(?![^>]*target=)/gi,
      '<a target="_blank" rel="noopener noreferrer"',
    )
    .replace(
      /<a(?![^>]*style=)/gi,
      '<a style="color: var(--color-4); text-decoration: underline;"',
    )
    .replace(/\r\n|\n|\r/g, '<br />')
    .replace(/(<br\s*\/?>\s*)+$/gi, '')
    .trim();
};
export const CustomRadioCatalog = (
  options: any,
  value: any,
  onChange: any,
  itemStyle?: CSSProperties,
) => {
  return (
    <Row gutter={[11, 11]}>
      {options.map((item, index) => (
        <Col key={item?.value ?? index} span={24}>
          <StyledCheckbox
            checked={value === item?.value}
            value={item?.value}
            onChange={onChange}
            antCheckboxWrapperCSS={{
              width: '100%',
            }}
          >
            <span style={{ fontWeight: 400, ...itemStyle }}>{item?.label}</span>
          </StyledCheckbox>
        </Col>
      ))}
    </Row>
  );
};
